@for (contact of contactGroup.contacts; track contact) {
  <div class="celo-hoverable">
    @if (
      type !== "suggestions" || contact["type"] !== "Random" || !selectable
    ) {
      <div
        class="singlecardstyle"
        [ngClass]="{
          disabled: uneditableContactIds.has(contact.userId),
          selectable: !uneditableContactIds.has(contact.userId),
        }"
        matRipple
        [matRippleDisabled]="uneditableContactIds.has(contact.userId)"
        data-testid="contact-option"
        [attr.data-user-id]="contact.userId"
        [attr.data-contact-type]="type"
        [attr.role]="selectable ? 'checkbox' : 'button'"
        [attr.tabindex]="uneditableContactIds.has(contact.userId) ? -1 : 0"
        [attr.aria-checked]="
          selectable ? !!selectedContactsMap[contact.userId] : null
        "
        [attr.aria-disabled]="uneditableContactIds.has(contact.userId)"
        (click)="click(contact)"
        (keydown.enter)="click(contact)"
        (keydown.space)="click(contact); $event.preventDefault()"
      >
        @if (isAddingParticipants && uneditableContactIds.has(contact.userId)) {
          <div class="added">Added</div>
        }
        @if (selectable) {
          <div class="selector" [ngClass]="{ select_mode: selectable }">
            @if (
              !uneditableContactIds.has(contact.userId) &&
              !selectedContactsMap[contact.userId]
            ) {
              <i class="material-icons">check_box_outline_blank</i>
            }
            @if (
              uneditableContactIds.has(contact.userId) ||
              !!selectedContactsMap[contact.userId]
            ) {
              <i class="material-icons">check_box</i>
            }
          </div>
        }
        @if (
          type !== "suggestions" &&
          type !== "workspace" &&
          type !== "colleagues"
        ) {
          <div class="contact">
            <app-celo-user-card
              [userId]="contact.userId"
              [contact]="contact"
              [replaceMyName]="
                contact.firstName + ' ' + contact.lastName + ' (You)'
              "
              [profileId]="userAccount.userId"
              [workspaces]="contact.workplaces"
              [title]="contact.title"
              [firstName]="contact.firstName"
              [lastName]="contact.lastName"
              [profilePic]="contact.profilePic"
              [position]="contact.position"
              [showCompany]="showCompany"
              [showAllWorkspaces]="showAllWorkspaces"
              [department]="contact.department"
              [showDepartment]="showDepartment"
              [hideWorkspace]="hideWorkspace"
              [identityVerificationStatus]="contact.identityVerificationStatus"
              [showBadge]="true"
              [hideProfession]="hideProfession"
              [profession]="
                contact.professions &&
                contact.professions[0] &&
                contact.professions[0] &&
                contact.professions[0].category
                  ? contact.professions[0].profession
                  : ''
              "
              [professionVerified]="
                contact.professions &&
                contact.professions[0] &&
                contact.professions[0].verificationStatus === 'Verified'
              "
            >
            </app-celo-user-card>
          </div>
        }
        <!-- Workspaces in search results -->
        @if (type === "workspace" && !companyInFocus) {
          <div class="contact">
            <app-celo-user-card
              [companyInFocus]="companyInFocusMap[contact.userId]"
              [companyInFocusId]="
                $safeNavigationMigration(companyInFocusMap[contact.userId]?.id)
              "
              [userId]="contact.userId"
              [contact]="contact"
              [replaceMyName]="
                contact.firstName + ' ' + contact.lastName + ' (You)'
              "
              [profileId]="userAccount.userId"
              [workspaces]="contact.workplaces"
              [title]="contact.title"
              [firstName]="contact.firstName"
              [lastName]="contact.lastName"
              [profilePic]="contact.profilePic"
              [position]="contact.position"
              [hideWorkspace]="hideWorkspace"
              [identityVerificationStatus]="contact.identityVerificationStatus"
              [showBadge]="true"
            >
            </app-celo-user-card>
          </div>
        }
        <!-- Workspaces on the new-chat screen -->
        @if (type === "workspace" && companyInFocus) {
          <div class="contact">
            <app-celo-user-card
              [companyInFocus]="companyInFocusMap[contact.userId]"
              [companyInFocusId]="
                $safeNavigationMigration(companyInFocusMap[contact.userId]?.id)
              "
              [userId]="contact.userId"
              [contact]="contact"
              [replaceMyName]="
                contact.firstName + ' ' + contact.lastName + ' (You)'
              "
              [profileId]="userAccount.userId"
              [workspaces]="contact.workplaces"
              [title]="contact.title"
              [firstName]="contact.firstName"
              [lastName]="contact.lastName"
              [profilePic]="contact.profilePic"
              [position]="contact.position"
              [hideWorkspace]="hideWorkspace"
              [identityVerificationStatus]="contact.identityVerificationStatus"
              [showBadge]="true"
              [onlyShowPosition]="true"
            >
            </app-celo-user-card>
          </div>
        }
        @if (type === "colleagues") {
          <div class="contact">
            <app-celo-user-card
              [companyInFocus]="companyInFocusMap[contact.userId]"
              [companyInFocusId]="
                $safeNavigationMigration(companyInFocusMap[contact.userId]?.id)
              "
              [userId]="contact.userId"
              [contact]="contact"
              [replaceMyName]="
                contact.firstName + ' ' + contact.lastName + ' (You)'
              "
              [profileId]="userAccount.userId"
              [workspaces]="contact.workplaces"
              [title]="contact.title"
              [firstName]="contact.firstName"
              [lastName]="contact.lastName"
              [profilePic]="contact.profilePic"
              [hideWorkspace]="hideWorkspace"
              [identityVerificationStatus]="contact.identityVerificationStatus"
              [showBadge]="true"
            >
            </app-celo-user-card>
          </div>
        }
        @if (type === "suggestions") {
          <div class="contact">
            <app-celo-user-card
              [userId]="contact.userId"
              [contact]="contact"
              [workspaces]="contact.workplaces"
              [title]="contact.title"
              [firstName]="contact.firstName"
              [lastName]="contact.lastName"
              [profilePic]="contact.profilePic"
              [position]="contact.position"
              [showCompany]="showCompany"
              [showAllWorkspaces]="showAllWorkspaces"
              [department]="contact.department"
              [showDepartment]="showDepartment"
              [hideWorkspace]="hideWorkspace"
              [identityVerificationStatus]="
                contact.identityVerified ? 'Verified' : 'Unverified'
              "
              [showBadge]="true"
              [hideProfession]="hideProfession"
              [profession]="contact.profession"
              [professionVerified]="contact.professionVerified"
              [isWorkspaceVerified]="contact.workspaceVerified"
            >
            </app-celo-user-card>
          </div>
        }
      </div>
    }
  </div>
}
